import React from "react";
import LocalShippingOutlinedIcon from "@material-ui/icons/LocalShippingOutlined";
import AirportShuttleOutlinedIcon from "@material-ui/icons/AirportShuttleOutlined";
import MotorcycleOutlinedIcon from "@material-ui/icons/MotorcycleOutlined";
import DirectionsCarOutlinedIcon from "@material-ui/icons/DirectionsCarOutlined";
import { esTractor, esAcoplado, esMoto, esAuto, esFurgon } from "./utils/vehicleInsideRow";
import type { VehicleInsideRole } from "../../../../passapp-sdk/types/userTypes";

/** El acoplado no tiene icono propio en @material-ui/icons v4, así que va dibujado a mano. */
const TrailerIcon = ({ fontSize = 20 }: { fontSize?: number }) => (
  <svg
    width={fontSize}
    height={fontSize}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M4 6h16v10H4z" />
    <circle cx="9" cy="18" r="1.8" />
    <circle cx="15" cy="18" r="1.8" />
    <path d="M4 11H1" />
  </svg>
);

type VehicleTypeIconProps = {
  role?: VehicleInsideRole;
  vehicleTypeName?: string | null;
};

/**
 * Icono de la unidad. Manda el `role` del backend para tractor/acoplado; el resto de las
 * carrocerías (auto, moto, furgón…) no tiene rol propio, así que se clasifican sólo por el nombre
 * del catálogo `vehicleTypes` — ver `esMoto`/`esAuto`/`esFurgon`.
 */
export const VehicleTypeIcon = ({ role, vehicleTypeName }: VehicleTypeIconProps) => {
  if (esTractor({ role, vehicleTypeName })) return <LocalShippingOutlinedIcon fontSize="small" />;
  if (esAcoplado({ role, vehicleTypeName })) return <TrailerIcon />;
  if (esMoto({ vehicleTypeName })) return <MotorcycleOutlinedIcon fontSize="small" />;
  if (esAuto({ vehicleTypeName })) return <DirectionsCarOutlinedIcon fontSize="small" />;
  if (esFurgon({ vehicleTypeName })) return <AirportShuttleOutlinedIcon fontSize="small" />;
  // Sin carrocería ni rol se asume auto, igual que `tipoLabel`.
  return <DirectionsCarOutlinedIcon fontSize="small" />;
};

export default VehicleTypeIcon;
